import sDocumentAxios from "./statistic-documents.service";
// import axios from "./config.service";

export interface UserDocsType {
  docId: number;
  fileId: number;
  departmentCode: string;
  departmentName: string;
  docName: string;
  docType: string;
  docStatus: string;
  publishDay: string;
  effectiveDate: string;
  seen?: boolean;
}

export interface DocsByDepartmentType {
  docId: number;
  fileId: number;
  departmentCode: string;
  departmentName: string;
  docName: string;
  docType: string;
  docStatus: string;
  publishDay: string;
  effectiveDate: string;
  quantityRead?: number;
  quantityUnread?: number;
}

export interface UpdateDocsUserType {
  docId: number;
  listIssusedUser: IssueUserRequest[];
}

export interface IssueUserRequest {
  departmentId: number;
  employeeCode?: string;
  employeeEmail?: string;
  departmentCode?: string;
  departmentName?: string;
}

export class StatisticsEmployeeService {
  static async getDocOfUser(employeeCode: string) {
    const res = await sDocumentAxios.get<{ data: UserDocsType[]; statusCode: number }>("/edoc/get-doc-of-user", {
      params: { employeeCode: employeeCode },
    });
    return res.data?.data;
  }

  static async getDocForDepartment(departmentCode: string) {
    const res = await sDocumentAxios.get<{ data: DocsByDepartmentType[]; statusCode: number }>(
      "/edoc/get-doc-statistic-by-department",
      {
        params: { departmentCode: departmentCode },
      },
    );
    return res.data.data;
  }

  static async addPublishDocForUsers(fields: any) {
    try {
      const res = await sDocumentAxios.post("edoc/create-doc-n-issused-person", fields);
      if (res.data.statusCode !== 200) return res.data;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async updatePublishDocForUsers(fields: UpdateDocsUserType) {
    try {
      const res = await sDocumentAxios.post("edoc/update-doc-n-issused-person", fields);
      if (res.data.statusCode !== 200) return res.data;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }
  static async addDocForUsers(fields: any) {
    try {
      const res = await sDocumentAxios.post("edoc/create-doc-n-person", fields);
      if (res.data.statusCode !== 200) return res.data;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async updateUserReadDoc(fields: any) {
    try {
      const res = await sDocumentAxios.post("edoc/update-user-read-doc", fields);
      if (res.data.statusCode !== 200) return res.data;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }
}
